import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowExpand01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M7.2 21.6H2.4m0 0v-4.8m0 4.8 5.4-5.4m9-13.8h4.8m0 0v4.8m0-4.8-5.4 5.4M2.4 7.2V2.4m0 0h4.8m-4.8 0 5.4 5.4m13.8 9v4.8m0 0h-4.8m4.8 0-5.4-5.4"
    />
  </svg>
);
export default SvgArrowExpand01;
